
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13 5.333H3.276l3.529-3.528-.943-.943L.724 6l5.138 5.138.943-.943-3.529-3.528H13V5.333z","fill":"#04080E"}})])
          )
        }
      }
    